import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CdkDragMove } from '@angular/cdk/drag-drop';

import { IArticle } from '../../../../prisma-xs/models/article.model';
import { IElementSize } from '../../../../prisma-xs/models/grid-elements.model';
import { ICdkDragPreview } from '../../../../prisma-xs/models/prisma-xs.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    standalone: false
})
export class AccordionComponent {
  @Input() title: string;
  @Input() groupImage: string;
  @Input() isOpened = false;
  @Input() contentClassName: string;
  @Input() disabledTitle: boolean;
  @Input() dragGroupNotAllowed: boolean;
  @Input() gridList;
  @Input() dragAndDropAllowed: boolean;
  @Input() hideTitle = false;
  @Input() showBadgeNew;

  @Input() set shouldOpenAccordion(data: boolean) {
    if (typeof data === 'boolean') {
      this.isOpened = data;

      if (!data) {
        setTimeout(() => this.updateElementHeight(), 0);
      }

      setTimeout(() => this.updateAccordionHeight(), 0);
    }
  }

  @Input() dragFromGroupLevelAllowed: boolean;
  @Input() dragData: IArticle;
  @Input() groupImagePreviewDimensions: IElementSize;

  @Output() dragElement = new EventEmitter<ICdkDragPreview>();
  @Output() endDrag = new EventEmitter();

  @ViewChild('element') element: ElementRef;

  toggleAccordion() {
    this.isOpened = !this.isOpened;

    this.updateAccordionHeight();
  }

  private updateAccordionHeight() {
    if (this.element.nativeElement.style.maxHeight) {
      this.element.nativeElement.style.maxHeight = null;
    } else {
      this.updateElementHeight();
    }
  }

  updateElementHeight() {
    this.element.nativeElement.style.maxHeight = this.element.nativeElement.scrollHeight + 104 + 'px';
  }

  dragElementOnGrid(element: CdkDragMove<IArticle>) {
    this.dragElement.emit({ element, previewDimensions: this.groupImagePreviewDimensions });
  }

  dragEnd() {
    this.endDrag.emit();
  }
}
